module.exports = __webpack_public_path__ + "img/map-japan.d0860f76.jpg";